/* eslint-disable */
export default {
  infoMessageMins:
    'Inicio de sesión guardado automáticamente en{delayTime}minutos...',
  infoMessageMin:
    'Inicio de sesión guardado automáticamente en{delayTime}minuto...',
  infoMessageSecs:
    'Inicio de sesión guardado automáticamente en{delayTime}segundos...',
  infoMessageSec:
    'Inicio de sesión guardado automáticamente en{delayTime}segundo...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
